<template>
  <div class="card mx-auto mt-5" style="width: 18rem;">
    <div class="card-body">
      <div class="form-group">
        <label for="username">Username</label>
        <input id="username" class="form-control" type="text" v-model="username">
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input id="password" class="form-control" type="password" v-model="password" @keydown="onKeyDown">
      </div>
      <button class="btn btn-primary" v-on:click="login">Login</button>
      <div v-if="failed" class="alert alert-danger mt-3" role="alert">
        Wrong username/password
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      failed: false
    }
  },
  methods: {
    ...mapActions(['loadSongs', 'loginUser']),
    login() {
      this.failed = false;
      this.loginUser({username: this.username, password: this.password})
        .then((res, err) => {
          if (err) {
            this.failed = true;
          } else {
            this.loadSongs();
            this.$router.push('/');
          }
        }).catch((err) => {
          console.log('Error while login in', err);
          this.failed = true;
      })
    },
    onKeyDown(e) {
      if (e.key === 'Enter') {
        this.login();
      }
    }
  }
}
</script>

<style>
</style>
